import { render, staticRenderFns } from "./batch-live-modal.vue?vue&type=template&id=4e1dc6ac&scoped=true"
import script from "./batch-live-modal.vue?vue&type=script&lang=js"
export * from "./batch-live-modal.vue?vue&type=script&lang=js"
import style0 from "./batch-live-modal.vue?vue&type=style&index=0&id=4e1dc6ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1dc6ac",
  null
  
)

export default component.exports